import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { CompraContext } from 'app/main/compra/CompraContext';
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext } from 'react';
import { compraModais } from '../compraModais';
import CompraBuscaAvancadaForm from './CompraBuscaAvancadaForm';

const CompraBuscaAvancadaModal = ({ fetchCompras }) => {
  const [modal, setModal] = useContext(CompraContext).modal;
  const [filtroAvancado, setFiltroAvancado] = useContext(CompraContext).filtroAvancado;
  const [search] = useContext(CompraContext).search;
  const [size] = useContext(CompraContext).size;
  const [sort] = useContext(CompraContext).sort;

  const handleSubmit = (values) => {
    const filtroAvancado = {
      ...values,
      fornecedorId: values?.fornecedor?.id,
      categoriaId: values?.categoria?.id,
      produtoId: values?.produto?.id,
    };

    delete filtroAvancado.fornecedor;
    delete filtroAvancado.categoria;
    delete filtroAvancado.produto;

    setFiltroAvancado(filtroAvancado);
    fetchCompras({ q: search, filtroAvancado, size, sort });
    setModal('');
  };

  const handleCancelar = () => {
    const close = () => {
      formik.resetForm(formik.initialValues);
      setModal('');
    };

    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const formik = useFormik({
    initialValues: {
      compraId: filtroAvancado.compraId,
      dataCompra: filtroAvancado.data,
      fornecedor: filtroAvancado.fornecedor,
      categoria: filtroAvancado.categoria,
      produto: filtroAvancado.produto,
      imobilizado: filtroAvancado.imobilizado,
    },
    onSubmit: handleSubmit,
  });

  return (
    <SimpleDialog open={modal === compraModais.buscaAvancada} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Busca Avançada',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Aplicar
                </SaveButton>
              </>
            ),
          }}
          content={<CompraBuscaAvancadaForm />}
          contentStyle={{ padding: 0 }}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};
export default CompraBuscaAvancadaModal;
